/**
 * All known adunits
 *
 * Format: {platform}-{page}-{type}-{extraPlace}-{size}
 *
 * E.g. d-dp-d-si-300x250
 * d: desktop
 * dp: devpage
 * d: display
 * si: sidebar
 * 300x250: size
 */ export const ADUNIT_MAP = {
    DesktopDevPageDisplaySide300x250: 'd-dp-d-si-300x250',
    DesktopDevPageSideVideoSide: 'd-dp-v-si',
    DesktopDevPageDisplayStage728x90: 'd-dp-d-st-728x90',
    DesktopProfileVideo: 'd-up-v',
    MobileAdhesion: 'm-anchor',
    MobileDevPageVideoStage: 'm-dp-v-st'
};
export const ADUNIT_IDS = Object.values(ADUNIT_MAP);
export var AdProviders;
(function(AdProviders) {
    AdProviders["Nitro"] = 'nitro';
})(AdProviders || (AdProviders = {}));
